type ArrowDirectionIconProps = {
  size?: number;
  strokeWidth?: number;
  className?: string;
};

export function DoubleArrowHorizontal({
  size = 64,
  strokeWidth = 5,
  className,
}: ArrowDirectionIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M20 16L4 32L20 48" />
      <path d="M44 16L60 32L44 48" />
      <path d="M6 32H58" />
    </svg>
  );
}

export function DoubleArrowConverging({
  size = 64,
  strokeWidth = 5,
  className,
}: ArrowDirectionIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M4 32H28" />
      {/* Left arrow head pointing right (apex at x=28, 16-unit wings) */}
      <path d="M12 16L28 32L12 48" />
      {/* Right arrow ← : long shaft from outer right to the inner tip */}
      <path d="M60 32H36" />
      {/* Right arrow head pointing left (apex at x=36, 16-unit wings) */}
      <path d="M52 16L36 32L52 48" />
    </svg>
  );
}
